import React from 'react';
import { ArrowRight, BadgePercent, Gift } from 'lucide-react';

import { Badge } from '../ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { formatCurrencyAmount } from '../../lib/currency';
import { EmptyState } from '../common/States';

const SuperadminDiscountsPanel = ({ summary, rows, onNavigate }) => {
  return (
    <Card className="animate-slide-up overflow-hidden border-purple/20 bg-gradient-to-br from-card via-card to-purple/5">
      <CardHeader className="border-b border-border">
        <div className="flex items-start justify-between gap-3">
          <div>
            <CardTitle className="flex items-center gap-2">
              <BadgePercent className="h-4 w-4 text-purple" />
              Discounts Offered
            </CardTitle>
            <CardDescription>Commercial levers across plan upgrades and renewals</CardDescription>
          </div>
          <button
            type="button"
            onClick={() => onNavigate?.('billing/discounts')}
            className="rounded-full p-2 text-muted-foreground transition-colors hover:bg-muted hover:text-purple"
          >
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </CardHeader>
      <CardContent className="space-y-5 pt-5">
        <div className="grid grid-cols-2 gap-3">
          <div className="rounded-xl border border-border bg-card p-4">
            <p className="text-xs font-medium text-muted-foreground">Discount Value</p>
            <p className="mt-2 text-2xl font-semibold text-foreground">{formatCurrencyAmount(summary.discounts_offered || 0, 'INR')}</p>
          </div>
          <div className="rounded-xl border border-border bg-card p-4">
            <p className="text-xs font-medium text-muted-foreground">Active Offers</p>
            <p className="mt-2 text-2xl font-semibold text-foreground">{summary.active_discounts || 0}</p>
          </div>
        </div>

        <div className="space-y-3">
          {(rows || []).slice(0, 5).map((row, index) => (
            <div
              key={row.id}
              className="animate-slide-up rounded-xl border border-border bg-card p-4 transition-all duration-200 hover:-translate-y-0.5 hover:border-purple/25 hover:shadow-sm"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="text-sm font-semibold text-foreground">{row.title}</p>
                  <p className="mt-1 text-xs text-muted-foreground">{row.tenant_name} • {row.plan_name}</p>
                </div>
                <Badge variant={row.status === 'active' ? 'success' : row.status === 'redeemed' ? 'info' : 'outline'}>
                  {row.status}
                </Badge>
              </div>
              <div className="mt-3 flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Estimated Value</span>
                <span className="font-semibold text-purple">{formatCurrencyAmount(row.estimated_discount_amount || 0, row.currency_code || 'INR')}</span>
              </div>
              <div className="mt-1 flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Offer Type</span>
                <span className="inline-flex items-center gap-1 font-medium text-foreground">
                  <Gift className="h-3.5 w-3.5" />
                  {row.discount_type} {Number(row.discount_value || 0)}
                </span>
              </div>
            </div>
          ))}
          {(!rows || rows.length === 0) && (
            <EmptyState
              compact
              icon={Gift}
              title="No discounts available"
              description="Commercial offers and incentives will be listed here."
            />
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default SuperadminDiscountsPanel;
